// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// const API_BASE_URL = 'http://localhost:5003';
const API_BASE_URL = 'https://dev-api.astpl.com.sg';
// const API_BASE_URL = 'https://api.astpl.com.sg';

export const environment = {
  production: false,
  apiBaseUrl: API_BASE_URL,
  graphqlUrl: `${API_BASE_URL}/graphql`,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
